import { ReactNode } from 'react';
import { Navigate, } from 'react-router-dom';

import { useSessionContext } from '../useSessionContext';
import { PATHS_MANAGE, } from 'routes/paths';
import { AccountRole } from '@piccadilly-cloud/platform-services';

// ----------------------------------------------------------------------

type SolverGuardProps = {
  children: ReactNode;
};

export default function SolverGuard({ children }: SolverGuardProps) {
  const { account } = useSessionContext();

  const facilitatorRoles: Record<AccountRole, boolean> = {
    'ROOT': true,
    'ACCOUNT_HOLDER': false,
    'SINGLE_COHORT_FACILITATOR': false,
    'FACILITATOR': false,
    'SINGLE_GROUP_FACILITATOR': false,
    'SOLVER': true,
    'GUEST': false,
  }

  if (!facilitatorRoles[account.accountRole]) {
    return <Navigate to={PATHS_MANAGE.dashboard} />
  }

  return <>{children}</>;
}
